const DEFAULT_ROOT_KEY = "_form";

const isPlainObject = (value) => {
    return !!value && typeof value === "object" && !Array.isArray(value);
};

const mapBackendFieldName = (fieldName) => {
    return fieldName
        .replace(/items\[(\d+)\]\.(\w+)/g, "item_$1_$2")
        .replace(/serviceBills\[(\d+)\]\.(\w+)/g, "service_$1_$2");
};

export const extractServerErrors = (error) => {
    if (isPlainObject(error) && !error.response) {
        return error;
    }

    if (isPlainObject(error?.response?.data?.errors)) {
        return error.response.data.errors;
    }

    if (typeof error?.response?.data?.message === "string") {
        return { [DEFAULT_ROOT_KEY]: error.response.data.message };
    }

    if (typeof error?.message === "string") {
        return { [DEFAULT_ROOT_KEY]: error.message };
    }

    return {};
};

export const handleServerErrors = (error, options = {}) => {
    const { setError, setErrors, fieldMapper = mapBackendFieldName } = options;
    const serverErrors = extractServerErrors(error);
    const normalizedErrors = {};

    Object.entries(serverErrors).forEach(([rawField, message]) => {
        const mappedField = typeof fieldMapper === "function" ? fieldMapper(rawField) : rawField;
        const safeMessage = String(message || "Invalid value");
        normalizedErrors[mappedField] = safeMessage;

        if (setError && mappedField !== DEFAULT_ROOT_KEY) {
            setError(mappedField, { type: "server", message: safeMessage });
            return;
        }

        if (setErrors) {
            setErrors((prev) => ({
                ...prev,
                [mappedField]: safeMessage
            }));
        }
    });

    return normalizedErrors;
};

